<template>
  <div class="wrapper">
    <blockquote
      class="instagram-media"
      :data-instgrm-permalink="src"
      data-instgrm-version="12"
      style=" background:#FFF; border:0; border-radius:3px; box-shadow:0 0 1px 0 rgba(0,0,0,0.5),0 1px 10px 0 rgba(0,0,0,0.15); margin: 1px; max-width:540px; min-width:326px; padding:0; width:99.375%; width:-webkit-calc(100% - 2px); width:calc(100% - 2px);"
    ></blockquote>
  </div>
</template>

<script>
export default {
  name: "app-instagram",
  props: {
    id: {
      type: String,
      required: true
    }
  },
  computed: {
    src() {
      return `https://www.instagram.com/p/${this.id}?hidecaption=true`;
    }
  },
  methods: {
    handler() {
      instgrm.Embeds.process();
    }
  },
  mounted() {
    if (!document.getElementById("instagramEmbed")) {
      const script = document.createElement("script");
      script.id = "instagramEmbed";
      script.async = true;
      script.src = "https://www.instagram.com/embed.js";
      script.onload = this.handler;
      document.getElementsByTagName("head")[0].appendChild(script);
    }
  }
};
</script>

<style scoped lang="scss">
.wrapper {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
</style>
